import React from 'react';
export function AboutSection() {
  return <section className="py-16 md:py-24 bg-slate-950 px-4" data-id="element-9">
      <div className="max-w-5xl mx-auto" data-id="element-10">
        <div className="bg-slate-900 rounded-3xl shadow-xl border border-slate-800 overflow-hidden flex flex-col md:flex-row" data-id="element-11">
          <div className="md:w-2/5 bg-slate-800 relative min-h-[300px]" data-id="element-12">
            <img src="https://cdn.magicpatterns.com/uploads/sMRW6PgnA73v8Db72B2n3s/IMG-20240411-WA0206.jpg" alt="Bruno - Instructor" className="absolute inset-0 w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" data-id="element-13" />
          </div>

          <div className="md:w-3/5 p-8 md:p-12 flex flex-col justify-center" data-id="element-14">
            <h2 className="text-3xl font-bold text-white mb-6" data-id="element-15">
              Quién es Bruno
            </h2>

            <div className="space-y-4 text-slate-400 leading-relaxed" data-id="element-16">
              <p data-id="element-17">
                Soy Bruno, Content Manager en School of Hard Knocks, una de las
                empresas de contenido de negocios más grandes de EE.UU.
              </p>
              <p data-id="element-18">
                Hace más de 4 años trabajo creando y gestionando contenido que
                genera billones de vistas al año y millones en resultados.
              </p>
              <p data-id="element-19">
                Empecé desde cero a los 15 años mientras estudiaba en la
                escuela, y convertí la edición en una fuente real de ingresos.
                Este curso existe para ahorrarte ese camino, dándote las
                herramientas exactas que uso todos los días con clientes de alto
                nivel.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}